import React from 'react'

export default function WarehouseFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        :root {
          --delete-button-color: transparent; /*to simply hide it*/
        }

        #warehouse-container {
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          height: 100%;
        }

        #warehouse-form-wrapper {
          display: flex;
          box-sizing: border-box;
          height: 90%;
        }

        #warehouse-form {
          display: flex;
          flex-direction: column;
          flex: 1.3;
          padding: 10px;
        }
        #warehouse-form label {
          margin: 5px 5px;
          font-size: 0.9rem;
        }
        #warehouse-form input {
          padding: 10px;
          font-size: 1rem;
          border: solid 0.5px green;
        }

        #warehouse-list-wrapper {
          display: flex;
          flex-direction: column;
          border-left: blue solid 0.8px;
          flex: 2;
        }
        #warehouse-list {
          border: none;
          overflow: auto;
          padding: 10px;
          height: 100%;
        }
        #warehouse-total-summary {
          font-size: 0.9rem;
          background-color: lightgrey;
          padding: 5px;
        }

        .warehouse-item {
          display: flex;
          padding: 10px;
          border: solid 0.5px green;
          border-radius: 3px;
          background-color: whitesmoke;
        }

        .warehouse-item:disabled { color: black; opacity: 0.5; }
        .warehouse-item.active:hover, .warehouse-item.active:focus {
          transform: scale(1.003);
          box-shadow: 1px 1px 2px 1px #BBB;
          --delete-button-color: darkgrey;
        }

        .warehouse-icon {
          font-size: 3.6rem;
          display: flex;
          justify-content: center;
          margin: auto;
          color: green;
        }
        .warehouse-details-title { font-size: 1.1rem; }
        .warehouse-details-wrapper {
          font-size: 0.80rem;
          flex: 2;
          display: flex;
          flex-direction: column;
          margin: auto;
          margin-left: 5px;
        }

        .delete-button-container {
          display: flex;
          padding: 0;
          flex-direction: column;
          justify-content: flex-start;
        }
        .delete-button {
          border: none;
          background: transparent;
          border-radius: 50px;
          padding-left: 4px;
          padding-right: 4px;
          padding-buttom: 3px;
          color: var(--delete-button-color);
        }
        .delete-button:hover, .delete-button:focus {
          background-color: transparent;
          border: none;
          color: red;
        }

        .button-container {
          display: flex;
          justify-content: flex-end;
          padding: 10px;
        }

        .msgbox-warning {
          display: flex;
          color: red;
        }
        .msgbox-warning * {
          margin: auto 5px;
        }
      `}
      </style>
    </React.Fragment>
  )
}
